import Phaser from 'phaser';

let SwipeDelay = 2;
let lines = [];

/**
   * 
   * @param {Phaser.Scene} currentScene 
   * @param {string} nextSceneKey 
   * @param {string} tweenTransition 
   */
export function transitionScene (currentScene, nextSceneKey, tweenTransition) {
  currentScene.tweens.killAll();

  if (tweenTransition === 'horizontal') {
    const dist = currentScene.scale.width;

    const nextScene = currentScene.scene.get(nextSceneKey);
    currentScene.scene.run(nextSceneKey);

    nextScene.events.once(Phaser.Scenes.Events.CREATE, () => {
      nextScene.cameras.main.x += dist;
      currentScene.tweens.add({
        targets: currentScene.cameras.main,
        duration: 700,
        ease: Phaser.Math.Easing.Linear,
        props: { x: -1 * dist },
        onComplete: () => currentScene.scene.stop()
      });

      nextScene.tweens.add({
        targets: nextScene.cameras.main,
        duration: 700,
        ease: Phaser.Math.Easing.Linear,
        props: { x: 0 }
      });
    });
  }
  else if (tweenTransition === 'radial') {
    SwipeDelay = 2;

    const nextScene = currentScene.scene.get(nextSceneKey);
    currentScene.scene.run(nextSceneKey);
    doRadialSwipe(currentScene);
    currentScene.time.delayedCall(SwipeDelay * 360, () => {
      // start next scene and do radial unswipe
      doRadialUnSwipe(nextScene);
      currentScene.scene.stop();
    });
  }
  else {
    // game.stage.addChild(newScene);

    // var dist = game.canvas.height;

    // newScene.y += dist;
    // createjs.Tween.get(currentScene, { loop: false })
    //   .to({ y: -1 * dist }, 700, null)
    //   .call(Builder.cleanUp, [currentScene], Builder);

    // createjs.Tween.get(newScene, { loop: false })
    //   .to({ y: 0 }, 700, null);
  }
}

/**
 * 
 * @param {Phaser.Scene} currentScene 
 */
function doRadialSwipe (currentScene) {
  lines = [];

  const radius = currentScene.scale.width;

  for (let i = 0; i < 360; i++) {
    currentScene.time.delayedCall(i * SwipeDelay, transitionDrawLine, [currentScene, radius, i]);
  }
}

/**
 * 
 * @param {Phaser.Scene} scene 
 * @param {number} radius 
 * @param {number} degrees 
 */
function transitionDrawLine (scene, radius, degrees) {
  const line = scene.add.graphics({ lineStyle: { color: 0x000000, width: 10 } });
  const radians = (degrees * Math.PI) / 180;

  const x = Math.cos(radians) * radius;
  const y = Math.sin(radians) * radius;

  line.lineBetween(scene.scale.width / 2, scene.scale.height / 2, x + scene.scale.width / 2 , y + scene.scale.height / 2);

  lines.push(line);
}

/**
 * 
 * @param {Phaser.Scene} newScene 
 */
function doRadialUnSwipe (newScene) {
  lines = [];

  const radius = newScene.scale.width;

  for (let i = 0; i < 360; i++) {
    transitionDrawLine(newScene, radius, i);
  }

  transitionDeleteAllLines(newScene);
}

/**
 * 
 * @param {Phaser.Scene} scene 
 */
function transitionDeleteAllLines (scene) {
  for (let i = 0; i < 360; i++) {
    scene.time.delayedCall(i * SwipeDelay, transitionDeleteLine);
  }
}

function transitionDeleteLine () {
  const line = lines.shift();
  line.destroy();
}